import { RoutalPalette } from '@nx-smartmonkey/ui';
import styled from 'styled-components';

export const StyledRightPanel = styled.div`
  z-index: 450;
  background-color: ${RoutalPalette.neutral00};
  border-left: 1px solid ${RoutalPalette.neutral10};
  position: relative;
`;
